import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleEventRemoval(
  state: State,
  event: Boundaries["removeEvent"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      events: req.calendar.events.filter(({ uuid }) => event.uuid !== uuid),
    },
  }));
}

export { handleEventRemoval };
